import React from 'react';
import { observer } from 'mobx-react';
import {
    Box,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    TextField,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const BillingContactForm = observer(({ form, managers, cbExists, cbHasEmail, onContactModeChange, originalCBData, onRestoreChargebeeData, isCurrentlyCustomBilling }) => {
    const emailField = form.$('email');
    const firstNameField = form.$('firstName');
    const lastNameField = form.$('lastName');
    const contactModeField = form.$('contactMode');

    const handleContactChange = (value) => {
        const prevValue = contactModeField.value;
        contactModeField.set(value);
        
        if (value === 'chargebee_initial' && originalCBData) {
            if (onRestoreChargebeeData) {
                onRestoreChargebeeData();
            }
        } else if (value !== 'custom' && value !== prevValue) {
            if (onContactModeChange) {
                onContactModeChange(value, managers);
            }
        }
    };

    const handleFieldChange = (field) => (e) => {
        const currentMode = contactModeField.value;
        if (currentMode !== 'custom' && currentMode !== 'chargebee_initial') {
            contactModeField.set('custom');
        }
        if (currentMode === 'chargebee_initial') {
            contactModeField.set('custom');
        }
        field.onChange(e);
        // Validation happens automatically due to form options (validateOnChange, showErrorsOnChange)
    };

    const renderFormFields = () => (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField
                    variant="filled"
                    fullWidth
                    type="email"
                    name="email"
                    onChange={handleFieldChange(emailField)}
                    value={isCurrentlyCustomBilling ? 'sales@awarego.com' : emailField.value}
                    label={emailField.label}
                    required={!cbExists}
                    disabled={isCurrentlyCustomBilling}
                    error={!!(emailField.error)}
                    helperText={
                        isCurrentlyCustomBilling 
                            ? 'Custom billing enabled - email locked to sales@awarego.com'
                            : (emailField.error ? emailField.error : 'Note: If "Custom Billing" is selected, this email will be overridden with sales@awarego.com')
                    }
                    placeholder={emailField.placeholder}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField
                    variant="filled"
                    fullWidth
                    type="text"
                    name="firstName"
                    onChange={handleFieldChange(firstNameField)}
                    value={firstNameField.value}
                    label={firstNameField.label}
                    error={!!(firstNameField.error)}
                    helperText={firstNameField.error || ''}
                    placeholder={firstNameField.placeholder}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField
                    variant="filled"
                    fullWidth
                    type="text"
                    name="lastName"
                    onChange={handleFieldChange(lastNameField)}
                    value={lastNameField.value}
                    label={lastNameField.label}
                    error={!!(lastNameField.error)}
                    helperText={lastNameField.error || ''}
                    placeholder={lastNameField.placeholder}
                />
            </Grid>
        </Grid>
    );

    return (
        <Box mt={3}>
            <Typography variant="h6" gutterBottom align="center">Billing Contact</Typography>
            
            {cbExists && cbHasEmail ? (
                <Accordion defaultExpanded={false}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="subtitle2">Override customer billing contact</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box width="100%">
                            <Typography variant="caption" display="block" color="textSecondary" gutterBottom>
                                Only changed fields will be updated in Chargebee.
                            </Typography>

                            <FormControl variant="filled" fullWidth style={{ marginTop: 12 }}>
                                <InputLabel>Billing contact</InputLabel>
                                <Select
                                    name="contactMode"
                                    value={contactModeField.value}
                                    onChange={(e) => handleContactChange(e.target.value)}
                                >
                                    {cbExists && originalCBData && (
                                        <MenuItem value="chargebee_initial">Chargebee initial (unchanged)</MenuItem>
                                    )}
                                    <MenuItem value="custom">Custom</MenuItem>
                                    {managers.map((m) => (
                                        <MenuItem key={m.email} value={m.email}>{m.name || m.email}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <Box mt={2}>{renderFormFields()}</Box>
                        </Box>
                    </AccordionDetails>
                </Accordion>
            ) : (
                <Box>
                    <Typography variant="subtitle2" gutterBottom>Billing contact</Typography>
                    <Typography variant="caption" display="block" color="textSecondary" gutterBottom>
                        This contact will be set in Chargebee. Email is required only in Normal Billing case. In case of Custom Billing email will be always overriden with sales@awarego.com
                    </Typography>

                    <FormControl variant="filled" fullWidth style={{ marginTop: 12 }}>
                        <InputLabel>Billing contact</InputLabel>
                        <Select
                            name="contactMode"
                            value={contactModeField.value}
                            onChange={(e) => handleContactChange(e.target.value)}
                        >
                            {cbExists && originalCBData && (
                                <MenuItem value="chargebee_initial">Chargebee initial (unchanged)</MenuItem>
                            )}
                            <MenuItem value="custom">Custom</MenuItem>
                            {managers.map((m) => (
                                <MenuItem key={m.email} value={m.email}>{m.name || m.email}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <Box mt={2}>{renderFormFields()}</Box>
                </Box>
            )}
        </Box>
    );
});

export default BillingContactForm;
